// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "[data-v-35b266c2] .el-card__body{padding-top:0}.titleactive[data-v-35b266c2]{color:#475570!important}.title[data-v-35b266c2]{color:#8d9ab2}[data-v-35b266c2] .el-divider__text{color:rgba(48,49,51,.5)}.diaTitle[data-v-35b266c2]{position:absolute;top:23px;left:80px}.btnClass[data-v-35b266c2]{display:flow-root;margin-top:5px}", ""]);
// Exports
module.exports = exports;
